// NOTE: Migrated from @shopify/polaris React components to Polaris Web Components
// Removed: Card, Text, Tooltip, BlockStack, InlineStack, Badge, Button, Modal, Banner, Spinner, IndexTable, useIndexResourceState, Page, Icon, EmptySearchResult, InlineError
// Migrated to: s-section, s-text, shopify-tooltip, s-stack, s-badge, s-button, s-modal, s-banner, s-spinner, s-table, native state management, s-page, s-icon
import React, { useEffect, useState, useCallback } from "react";
import { environment } from "../../Services/environment";
import { getRestoreHistory, handlePlanError } from "../../Services/CommonServices";
import { errorMetaModal } from "../../common/ErrorModal";
import BackupProductsTable from "./BackupProductsTable";
import ImportHistory from "../../common/ImportHistory";
import ImportProcessing from "../../common/ImportProcessing";
const endpoint = environment.serverUrl;
export default function BackupsList({ storeUrl, eventSource }) {
  const queryString = window.location.search;
  
  const [backups, setBackups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedFilePath, setSelectedFilePath] = useState(null);
  const [isProductModalOpen, setIsProductModalOpen] = useState(false);
  const [selectedRestoreProductIds, setSelectedRestoreProductIds] = useState([]);
  const [isSelectAllActive, setIsSelectAllActive] = useState(false);
  const [totalProductCount, setTotalProductCount] = useState(0);
  const [isRestoring, setIsRestoring] = useState(false);
  const [restoreError, setRestoreError] = useState(null);
  const [restoreSuccess, setRestoreSuccess] = useState(null);

  // Pagination for backups list
  const [backupsPageNo, setBackupsPageNo] = useState(1);
  const [backupsPageSize] = useState(10);
  const [backupsTotalCount, setBackupsTotalCount] = useState(0);
  const [backupsTotalPages, setBackupsTotalPages] = useState(0);
  const [backupsNxtButton, setBackupsNxtButton] = useState(true);
  const [backupsPrvButton, setBackupsPrvButton] = useState(true);

  // Import processing states
  const [uploadStatus, setUploadStatus] = useState(false);
  const [bulkStatus, setBulkStatus] = useState("");
  const [pollingResult, setPollingResult] = useState(undefined);
  const [processingMsg, setProcessingMsg] = useState('calculating items');
  const [catalogExtractMsg, setCatalogExtractMsg] = useState();
  const [stagedUploadProgress, setStagedUploadProgress] = useState();
  const [splitProducts, setSplitProducts] = useState();
  const [productDeleteStatus, setProductDeleteStatus] = useState();
  const [metaDeleteStatus, setMetaDeleteStatus] = useState();
  const [productBulkCancelStatus, setProductBulkCancelStatus] = useState();
  const [processingProgress, setProcessingProgress] = useState(0);

  // Import history state
  const [logs, setLogs] = useState([]);
  const [logsLoading, setLogsLoading] = useState(false);
  const [nxtButton, setNxtButton] = useState(true);
  const [prvButton, setPrvButton] = useState(true);
  const [loadingMap, setLoadingMap] = useState({});
  const pageSize = 10;
  const [pageNo, setPageNo] = useState(1);
  const [pageCount, setPageCount] = useState(0);

  // Error modal states
  const [bulkErrorActive, setBulkErrorActive] = useState(false);
  const [bulkErrors, setBulkErrors] = useState([]);
  const [bulkMetaErrorActive, setBulkMetaErrorActive] = useState(false);
  const [bulkMetaErrors, setBulkMetaErrors] = useState([]);
  const [uploadWarningActive, setUploadWarningActive] = useState(false);
  const [uploadWarnings, setUploadWarnings] = useState([]);

  // Delete confirmation state
  const [deleteModalActive, setDeleteModalActive] = useState(false);
  const [backupToDelete, setBackupToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState(null);

  // Plan upgrade notification state
  const [upgradeNotification, setUpgradeNotification] = useState(null);

  const handleBulkErrorChangeModal = useCallback(() => setBulkErrorActive(!bulkErrorActive), [bulkErrorActive]);
  const handleMetaBulkErrorChangeModal = useCallback(() => setBulkMetaErrorActive(!bulkMetaErrorActive), [bulkMetaErrorActive]);
  const handleUploadWarningChangeModal = useCallback(() => setUploadWarningActive(!uploadWarningActive), [uploadWarningActive]);

  // Navigation to pricing page using App Bridge-compatible redirect
  const navigateToPricing = useCallback(() => {
    const pricingUrl = '/plans' + queryString;
    window.top.location.href = window.location.origin + pricingUrl;
  }, [queryString]);

  // Error modal generators
  function generateProductErrorModal(errors) {
    setBulkErrors(errors);
    setBulkErrorActive(true);
    // Open modal programmatically
    setTimeout(() => {
      const modal = document.getElementById('bulk-error-modal');
      if (modal) {
        modal.dispatchEvent(new CustomEvent('command', { detail: { action: 'show' } }));
      }
    }, 100);
  }

  function generateMetafieldErrorModal(errors) {
    setBulkMetaErrors(errors);
    setBulkMetaErrorActive(true);
  }

  function generateUploadWarningsModal(warnings) {
    setUploadWarnings(warnings);
    setUploadWarningActive(true);
    // Open modal programmatically
    setTimeout(() => {
      const modal = document.getElementById('upload-warnings-modal');
      if (modal) {
        modal.dispatchEvent(new CustomEvent('command', { detail: { action: 'show' } }));
      }
    }, 100);
  }

  // Cancel bulk operation
  async function cancelBulk(bulkId) {
    try {
      const response = await fetch(endpoint + `/api/Backup/cancel-bulk?storeUrl=${storeUrl}&bulkId=${bulkId}`, {
        method: 'POST'
      });
      if (response.ok) {
        setProductBulkCancelStatus("canceling");
        getLogs();
      }
    } catch (error) {
      console.error('Failed to cancel bulk operation:', error);
    }
  }


 
  // Fetch backups and logs
  useEffect(() => {
    fetchBackups();
    getLogs();
  }, []);

  // Reload backups when page changes
  useEffect(() => {
    fetchBackups();
  }, [backupsPageNo]);

  // Reload logs when page changes
  useEffect(() => {
    getLogs();
  }, [pageNo]);

  // SSE handler for real-time updates
  useEffect(() => {
    if (!eventSource) return;
    
    eventSource.onmessage = (event) => {
      const data = event.data;
      
      // Try to parse as structured SSE message first
      let parsedMessage = null;
      let eventType = null;
      let messageData = null;
      
      try {
        parsedMessage = JSON.parse(data);
        eventType = parsedMessage.eventType;
        messageData = parsedMessage.data;
      } catch (e) {
        // Fallback to legacy string-based parsing for non-typed messages
        console.warn("Received non-typed SSE message in BackupsList:", data);
      }
      
      // Handle typed SSE messages
      if (eventType === "BulkOperationStatus") {
        const { status, bulkId, objectCount, progress } = messageData;
        
        if (status.toLowerCase() === "completed") {
          setPollingResult(messageData);
          setBulkStatus(status);
          setUploadStatus(false);
          getLogs();
          fetchBackups(); // Refresh backups list
        } else if (status.toLowerCase() === "canceled") {
          setUploadStatus(false);
          setBulkStatus(status);
          getLogs();
        } else if (status.toLowerCase() === "failed") {
          setUploadStatus(false);
          setBulkStatus(status);
          setPollingResult(messageData);
          getLogs();
        } else {
          setUploadStatus(true);
          setBulkStatus(status);
          setPollingResult(messageData);
        }
      }
      else if (eventType === "ProductBackup") {
        const { operation, status, progress, message, productsProcessed, totalProducts } = messageData;
        console.log("Backup notification received:", messageData);
        
        if (operation === "restore") {
          setPollingResult({ 
            ...messageData,
            objectCount: productsProcessed,
            status: status 
          });
          setUploadStatus(true);
          setBulkStatus("processing");
          setProcessingMsg(message || "Restoring products");
          
          // Refresh backups and logs when restore completes
          if (status === "completed" || status === "error") {
            setTimeout(() => {
              getLogs();
              fetchBackups();
              setUploadStatus(false);
              setBulkStatus("");
            }, 1000);
          }
        } else if (operation === "backup") {
          // Handle backup creation notifications
          console.log("Backup creation progress:", messageData);
          if (status === "completed") {
            setTimeout(() => {
              fetchBackups(); // Refresh backups list when new backup is created
            }, 1000);
          }
        }
      }
      else if (eventType === "ProcessingProgress") {
        const { status, progress, message } = messageData || {};
        console.log("Processing progress:", { status, progress, message });
        setPollingResult(undefined);
        setUploadStatus(true);
        setBulkStatus("processing");
        setProcessingMsg(message || "processing");
        setProcessingProgress(progress || status || 0);
      }
      else if (eventType === "processingStarted") {
        const { operationId } = messageData || {};
        console.log("Processing started with operationId:", operationId);
        setUploadStatus(true);
        setBulkStatus("processing");
        setProcessingMsg("preparing");
      }
      else if (eventType === "bulkOperationCreated") {
        const { operationId, bulkId } = messageData || {};
        console.log("Bulk operation created for restore:", { operationId, bulkId });
        setUploadStatus(true);
        setBulkStatus("CREATED");
      }
      else if (eventType === "operationCanceled") {
        const { operationId, message } = messageData || {};
        console.log("Operation canceled early:", message);
        setProductBulkCancelStatus("Operation canceled before bulk operation started");
        setBulkStatus("cancelled");
        setUploadStatus(false);
        setProcessingMsg("");
        getLogs();
      }
      else if (eventType === "bulkOperationCanceled") {
        const { operationId, bulkId, message } = messageData || {};
        console.log("Bulk operation canceled:", message);
        setProductBulkCancelStatus("Bulk operation canceled in Shopify");
        setBulkStatus("cancelled");
        setUploadStatus(false);
        getLogs();
      }
      // Legacy string-based fallback handlers
      else if (data.includes("bulkId")) {
        const jsonObject = JSON.parse(data);
        if (jsonObject) {
          const { status } = jsonObject;

          if (status.toLowerCase() === "completed") {
            setPollingResult(jsonObject);
            setBulkStatus(status);
            setUploadStatus(false);
            getLogs();
            fetchBackups(); // Refresh backups list
          } else if (status.toLowerCase() === "canceled") {
            setUploadStatus(false);
            setBulkStatus(status);
            getLogs();
          } else {
            setUploadStatus(true);
            setBulkStatus(status);
            setPollingResult(jsonObject);
          }
        }
      } else if (data.includes("Product Restore")) {
        const jsonObject = JSON.parse(data);
        setPollingResult(undefined);
        setUploadStatus(true);
        setBulkStatus("processing");
        setProcessingMsg("Restoring products");
      } else if (data.includes("productRestoreProgress")) {
        const jsonObject = JSON.parse(data);
        setPollingResult(jsonObject);
        setUploadStatus(true);
        setBulkStatus("processing");
        setProcessingMsg("Restoring products");
      } else if (data.includes("ProcessingProgress")) {
        const jsonObject = JSON.parse(data);
        if (jsonObject) {
          const { status, progress } = jsonObject;
          console.log("Legacy ProcessingProgress handler:", { status, progress });
          setPollingResult(undefined);
          setUploadStatus(true);
          setBulkStatus("processing");
          setProcessingMsg("progress");
          setProcessingProgress(progress || status || 0);
        }
      }
    };

    return () => {
      if (eventSource) {
        eventSource.onmessage = null;
      }
    };
  }, [eventSource]);

 const handleSelectionRestoreChange = useCallback((selectedIds, selectAll, totalCount) => {
    console.log('Selection changed - IDs:', selectedIds, 'SelectAll:', selectAll, 'Total:', totalCount);
    setSelectedRestoreProductIds(selectedIds);
    setIsSelectAllActive(selectAll);
    setTotalProductCount(totalCount);
  }, []);

  const handleRestore = async () => {
    console.log('=== Parent handleRestore called ===');
    console.log('storeUrl:', storeUrl);
    console.log('selectedFilePath:', selectedFilePath);
    console.log('selectedRestoreProductIds:', selectedRestoreProductIds);
    console.log('isSelectAllActive:', isSelectAllActive);
    console.log('totalProductCount:', totalProductCount);
    
    setIsRestoring(true);
    setRestoreError(null);
    setRestoreSuccess(null);

    try {
      // Use the explicit selectAll flag from the child component
      const restoreAllProducts = isSelectAllActive;

      console.log('restoreAllProducts:', restoreAllProducts);
      console.log('Selected IDs length:', selectedRestoreProductIds.length);
      console.log('Total product count:', totalProductCount);

      const payload = {
        StoreUrl: storeUrl,          // Capital S and U to match API
        FilePath: selectedFilePath,  // Capital F and P to match API
        RestoreAllProducts: restoreAllProducts,  // Capital R, A, P to match API
        ProductIds: restoreAllProducts ? [] : selectedRestoreProductIds  // Capital P and I to match API
      };

      console.log('Parent payload:', JSON.stringify(payload, null, 2));

      const response = await fetch(endpoint + '/api/Backup/restore-products', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      if (response.status === 403) {
        const errorData = await response.json();
        if (errorData.requiresUpgrade) {
          setRestoreError(errorData.message || 'This feature requires a Pro plan subscription.');
          return;
        }
      }

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Server error response:', errorData);
        console.error('Response status:', response.status);
        throw new Error(errorData.message || errorData || 'Failed to restore products');
      }

      const result = await response.json();
      setRestoreSuccess(`Successfully initiated restore of ${result.productsToRestore} product(s). Bulk Operation ID: ${result.bulkOperationId}`);
      
      // Start import processing display
      setUploadStatus(true);
      setPollingResult(result);
      setBulkStatus("CREATED");
      
      // Reset selection after successful restore
      setSelectedRestoreProductIds([]);
      setIsSelectAllActive(false);
      setTotalProductCount(0);
      
      // Close modal using the proper web component command
      setTimeout(() => {
        const modal = document.getElementById('product-restore-modal');
        if (modal) {
          // Use the command attribute method for Polaris Web Components
          const closeButton = modal.querySelector('[command="--hide"]');
          if (closeButton) {
            closeButton.click();
          } else {
            // Fallback: try to set the open property to false
            modal.removeAttribute('open');
          }
        }
        setRestoreSuccess(null);
      }, 3000);

    } catch (err) {
      console.error('Restore error:', err);
      setRestoreError(err.message || 'Failed to restore products');
    } finally {
      setIsRestoring(false);
    }
  };

    const fetchBackups = async () => {
        setLoading(true);
        setUpgradeNotification(null);
        try {
            console.log("Fetching backups for store:", storeUrl);
            const response = await fetch(
              endpoint + `/api/Backup/${storeUrl}?pageNo=${backupsPageNo}&pageSize=${backupsPageSize}`
            );
            
            if (response.status === 403) {
              const errorData = await response.json();
              if (errorData.requiresUpgrade) {
                setUpgradeNotification({
                  message: errorData.message,
                  feature: errorData.feature
                });
                setBackups([]);
                setBackupsTotalCount(0);
                setBackupsTotalPages(0);
                setBackupsNxtButton(false);
                setBackupsPrvButton(false);
                return;
              }
            }
            
            if (!response.ok) {
              throw new Error('Failed to load backups');
            }
            
            const data = await response.json();
            setBackups(data.results || []);
            setBackupsTotalCount(data.totalCount || 0);
            setBackupsTotalPages(data.totalPages || 0);
            
            // Update pagination buttons
            setBackupsNxtButton(backupsPageNo < data.totalPages);
            setBackupsPrvButton(backupsPageNo > 1);
        } catch (err) {
            console.error("Failed to load backups:", err);
            setBackups([]);
        } finally {
            setLoading(false);
        }
    };

  function getLogs() {
    setLogsLoading(true);
    getRestoreHistory(storeUrl, pageNo, pageSize).then(function (result) {
      if (result !== null) {
        // Check for upgrade requirement
        if (result.requiresUpgrade) {
          setUpgradeNotification({
            message: result.message,
            feature: 'ProductRestore'
          });
          setLogs([]);
          setPageCount(0);
        } else {
          setLogs(result.results);
          setPageCount(Math.ceil(result.totalCount / pageSize));
        }
        setLogsLoading(false);
      }
      else {
        setLogsLoading(false);
      }
    });
  }

  function nxt() {
    if (pageNo < pageCount) {
      setPageNo(pageNo + 1);
      if (pageNo + 1 === pageCount) {
        setNxtButton(false);
        setPrvButton(true);
      }
      else { setPrvButton(true); setNxtButton(true); }
    }
    else { setNxtButton(false); setPrvButton(true) }
  }

  function prv() {
    if (pageNo > 1) {
      setPageNo(pageNo - 1);
      if (pageNo - 1 === 1) {
        setPrvButton(false);
        setNxtButton(true);
      }
      else { setPrvButton(true); setNxtButton(true); }
    }
    else { setPrvButton(false); setNxtButton(true) }
  }

  // Pagination functions for backups list
  function nxtBackups() {
    if (backupsPageNo < backupsTotalPages) {
      setBackupsPageNo(backupsPageNo + 1);
    }
  }

  function prvBackups() {
    if (backupsPageNo > 1) {
      setBackupsPageNo(backupsPageNo - 1);
    }
  }

  function generateProductErrorModal(errors) {
    setBulkErrors(errors);
    setBulkErrorActive(true);
  }

  function generateMetafieldErrorModal(errors) {
    setBulkMetaErrors(errors);
    setBulkMetaErrorActive(true);
  }

  function generateUploadWarningsModal(warnings) {
    setUploadWarnings(warnings);
    setUploadWarningActive(true);
  }

  async function downloadResult(op, bulkId) {
    setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: true }));
    try {
      const response = await fetch(endpoint + `/api/Backup/download-bulk-result?storeUrl=${storeUrl}&bulkId=${bulkId}&type=${op}`, {
        method: 'GET'
      });
      
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `restore-result-${storeUrl}-${op}.csv`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } else {
        console.error('Download failed:', response.statusText);
      }
    } catch (error) {
      console.error('Download error:', error);
    } finally {
      setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: false }));
    }
  }

  const resourceName = {
    singular: "backup",
    plural: "backups",
  };

  const handleView = (filePath) => {
    setSelectedFilePath(filePath);
    setSelectedRestoreProductIds([]);
    setIsSelectAllActive(false);
    setTotalProductCount(0);
    setRestoreError(null);
    setRestoreSuccess(null);
    setIsProductModalOpen(true);
    // Modal will open via commandFor on button click
  };

  const handleDownload = (filePath) => {
    window.open(`/api/backups/download?path=${encodeURIComponent(filePath)}`, "_blank");
  };

  const handleDeleteClick = (filePath, backupName) => {
    setBackupToDelete({ filePath, backupName });
    setDeleteError(null);
    setDeleteModalActive(true);
    // Modal will open via commandFor on button click
  };

  const handleDeleteConfirm = async () => {
    if (!backupToDelete) return;
    
    setIsDeleting(true);
    setDeleteError(null);

    try {
      const response = await fetch(
        `${endpoint}/api/Backup/delete-backup?storeUrl=${storeUrl}&filePath=${encodeURIComponent(backupToDelete.filePath)}`,
        {
          method: "DELETE",
        }
      );

      if (response.status === 403) {
        const errorData = await response.json();
        if (errorData.requiresUpgrade) {
          setDeleteError(errorData.message || 'This feature requires a Pro plan subscription.');
          return;
        }
      }

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to delete backup");
      }

      // Remove from local state
      setBackups((prev) => prev.filter((b) => b.filePath !== backupToDelete.filePath));
      
      // Close modal and reset
      setDeleteModalActive(false);
      setBackupToDelete(null);
    } catch (err) {
      console.error("Failed to delete backup:", err);
      setDeleteError(err.message || "Failed to delete backup");
    } finally {
      setIsDeleting(false);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteModalActive(false);
    setBackupToDelete(null);
    setDeleteError(null);
  };

  const rowMarkup = loading ? (
    <s-table-row>
      <s-table-cell></s-table-cell>
      <s-table-cell></s-table-cell>
      <s-table-cell>
        <s-stack alignItems="center" gap="base" padding="large">
          <s-spinner accessibilityLabel="Loading backups" size="large" />
        </s-stack>
      </s-table-cell>
    </s-table-row>
  ) : backups.length === 0 ? (
    <s-table-row>
      <s-table-cell></s-table-cell>
      <s-table-cell></s-table-cell>
      <s-table-cell>
        <s-box padding="large">
          <s-stack alignItems="center" gap="base" padding="large">
            <s-text variant="headingMd" as="h3">No backups found</s-text>
            <s-text variant="bodyMd" as="p" tone="subdued">There are no backups available.</s-text>
          </s-stack>
        </s-box>
      </s-table-cell>
    </s-table-row>
  ) : backups.map(
    ({ backupName, bulkOperationId, lastModified, sizeInMB, itemCount, filePath }, index) => (
      <s-table-row
        id={bulkOperationId}
        position={index}
        key={bulkOperationId}
      >
        <s-table-cell>
          <s-text variant="bodyMd" type="strong" as="span">
            #{bulkOperationId}
          </s-text>
        </s-table-cell>
        <s-table-cell>
          <s-text variant="bodyMd" as="span">
            {new Date(lastModified).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            })}
          </s-text>
        </s-table-cell>
        <s-table-cell>
          <s-badge tone="info">{sizeInMB.toFixed(2)} MB</s-badge>
        </s-table-cell>
        <s-table-cell>
          <s-text variant="bodyMd" as="span">
            {itemCount === -1 ? '—' : (itemCount ?? 0)}
          </s-text>
        </s-table-cell>
        <s-table-cell>
          <s-button
            icon="view"
            variant="tertiary"
            tone="success"
            commandFor="product-restore-modal"
            onClick={() => handleView(filePath)}
          />
          <s-button
            icon="delete"
            tone="critical"
            variant="tertiary"
            commandFor="delete-backup-modal"
            onClick={() => handleDeleteClick(filePath, backupName)}
          />
        </s-table-cell>
      </s-table-row>
    )
  );

  return (
        <>
        {upgradeNotification ? (

            <s-banner tone="warning">
                <s-box textAlign="center">
                    <s-heading>
                        Upgrade to Pro Plan Required
                    </s-heading>
                </s-box>
                    <s-text color="subdued">
                        {upgradeNotification.message}
                    </s-text>
                <s-divider />
                <s-stack gap="small">
                    <s-heading>
                        Product Backup & Restore features include:
                    </s-heading>
                    <s-unordered-list>
                        <s-list-item>Automatic daily product backups</s-list-item>
                        <s-list-item>One-click restore to any previous state</s-list-item>
                        <s-list-item>Protect against accidental data loss</s-list-item>
                        <s-list-item>View and restore individual products or entire catalogs</s-list-item>
                    </s-unordered-list>
                </s-stack>

                <s-divider />

                <s-button slot="secondary-actions" variant="secondary-actions" onClick={navigateToPricing}>
                    View Pricing Plans
                </s-button>
            </s-banner>
        ) : (
          <>
            {/* Backups Table */}
            <s-section padding="none">
          <s-box padding="base">
            <s-grid gridTemplateColumns="1fr auto" gap="none">
              <s-grid-item>
                <s-heading>Available Backups</s-heading>
              </s-grid-item>
              <s-grid-item>
                <s-text tone="subdued">View and restore your product backups</s-text>
              </s-grid-item>
            </s-grid>
          </s-box>
          <s-table 
            loading={loading}
            paginate={backupsTotalPages > 1}
            hasPreviousPage={backupsPrvButton}
            hasNextPage={backupsNxtButton}
            onPreviousPage={prvBackups}
            onNextPage={nxtBackups}
          >
            <s-table-header-row>
              <s-table-header>Import Id</s-table-header>
              <s-table-header>Date</s-table-header>
              <s-table-header>Size (MB)</s-table-header>
              <s-table-header>Products</s-table-header>
              <s-table-header>Actions</s-table-header>
            </s-table-header-row>
            <s-table-body>
              {rowMarkup}
            </s-table-body>
          </s-table>
        </s-section>

        {/* Import Processing */}
        <ImportProcessing
          bulkStatus={bulkStatus}
          uploadStatus={uploadStatus}
          pollingResult={pollingResult}
          setErrModalActive={setUploadWarningActive}
          processingMsg={processingMsg}
          catalogExtractMsg={catalogExtractMsg}
          stagedUploadProgress={stagedUploadProgress}
          splitItems={splitProducts}
          productDeleteStatus={productDeleteStatus}
          metaDeleteStatus={metaDeleteStatus}
          productBulkCancelStatus={productBulkCancelStatus}
          processingProgress={processingProgress}
          cancelBulk={cancelBulk}
          generateProductErrorModal={generateProductErrorModal}
          generateMetafieldErrorModal={generateMetafieldErrorModal}
        />

        {/* Import History Table */}
        <s-section padding="none">
          <s-box padding="base">
            <s-grid gridTemplateColumns="1fr auto" gap="none">
              <s-grid-item>
                <s-heading>Restore History</s-heading>
              </s-grid-item>
              <s-grid-item>
                <s-text tone="subdued">View your previously restored products</s-text>
              </s-grid-item>
            </s-grid>
          </s-box>
       
          <ImportHistory
            logs={logs}
            generateProductErrorModal={generateProductErrorModal}
            generateMetafieldErrorModal={generateMetafieldErrorModal}
            generateUploadWarningsModal={generateUploadWarningsModal}
            downloadResult={downloadResult}
            loadingMap={loadingMap}
            logsLoading={logsLoading}
            nxt={nxt}
            prv={prv}
            nxtButton={nxtButton}
            prvButton={prvButton}
            hideHeader={true}
          />
        </s-section>
      {/* </s-stack> */}
          </>
        )}
      
      {/* Product Restore Modal */}
      {!upgradeNotification && (
        <s-modal
          id="product-restore-modal"
          size="large"
          heading="Restore Products"
          padding="none"
        >
          <s-box padding="none">
            <s-stack gap="large">
              {restoreError && (
                <s-banner tone="critical" onDismiss={() => setRestoreError(null)}>
                  <s-text>{restoreError}</s-text>
                </s-banner>
              )}
              {restoreSuccess && (
                <s-banner heading="Restore Initiated" tone="success">
                  {restoreSuccess}
                </s-banner>
              )}
              
            </s-stack>
          </s-box>
          <BackupProductsTable 
                storeUrl={storeUrl} 
                filePath={selectedFilePath} 
                selectedRestoreProductIds={selectedRestoreProductIds}
                onSelectionRestoreChange={handleSelectionRestoreChange} 
              />
              
          <s-button 
            slot="secondary-actions" 
            commandFor="product-restore-modal" 
            command="--hide"
            disabled={isRestoring}
          >
            Cancel
          </s-button>
          <s-button 
            slot="primary-action"
            variant="primary" 
            onClick={handleRestore} 
            loading={isRestoring}
            disabled={!isSelectAllActive && selectedRestoreProductIds.length === 0}
          >
            Restore Selected
          </s-button>
        </s-modal>
      )}

      {/* Delete Confirmation Modal */}
      {!upgradeNotification && (
      <s-modal
        id="delete-backup-modal"
        heading="Delete Backup"
      >
        <s-stack gap="large">
          {deleteError && (
            <s-banner tone="critical">
              <s-text>{deleteError}</s-text>
            </s-banner>
          )}
          <s-text variant="bodyMd" as="p">
            Are you sure you want to delete this backup? This action cannot be undone.
          </s-text>
          {backupToDelete && (
            <s-text variant="bodyMd" as="p" tone="subdued">
              Backup: <s-text type="strong">{backupToDelete.backupName}</s-text>
            </s-text>
          )}
        </s-stack>
        <s-button 
          slot="secondary-actions" 
          commandFor="delete-backup-modal" 
          command="--hide"
          disabled={isDeleting}
        >
          Cancel
        </s-button>
        <s-button 
          slot="primary-action"
          variant="primary" 
          tone="critical" 
          onClick={handleDeleteConfirm} 
          loading={isDeleting}
        >
          Delete
        </s-button>
      </s-modal>
      )}

      {/* Error Modals */}
      {bulkErrors.length > 0 ? (
        <s-modal
          id="bulk-error-modal"
          size="large"
          heading="Failed Products"
        >
          {bulkErrors.map(
            ({ handle, userErrors }, index) => (
              <s-box key={index} padding="base" borderBlockEndWidth="025" borderColor="border">
                <s-stack gap="extra-small">
                  <s-text>#{index + 1}&nbsp;Handle: {handle}</s-text>
                  {userErrors.map(
                    ({ message }, idx) => (
                      <s-banner key={idx} tone="critical">
                        <s-text>{message}</s-text>
                      </s-banner>
                    ))}
                </s-stack>
              </s-box>
            ))}
          <s-button 
            slot="secondary-actions" 
            commandFor="bulk-error-modal" 
            command="--hide"
          >
            Close
          </s-button>
        </s-modal>
      ) : null}

      {errorMetaModal({ bulkMetaErrorActive, handleMetaBulkErrorChangeModal, bulkMetaErrors })}

      {uploadWarnings.length > 0 ? (
        <s-modal
          id="upload-warnings-modal"
          size="large"
          heading="Upload Warnings"
        >
          {uploadWarnings.map((warning, index) => (
            <s-box key={index} padding="base" borderBlockEndWidth="025" borderColor="border">
              <s-stack gap="extra-small">
                <s-text>#{index + 1}&nbsp;{warning}</s-text>
              </s-stack>
            </s-box>
          ))}
          <s-button 
            slot="secondary-actions" 
            commandFor="upload-warnings-modal" 
            command="--hide"
          >
            Close
          </s-button>
        </s-modal>
      ) : null}
   </>
  );
}
